import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from '@/components/ui/dialog'

import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useToast } from '@/components/ui/use-toast'
import { deleteProductInMarketResearch } from '@/api/business/marketResearch'
import { ProductInMarketResearchKeys } from '@/queries/useProductInMarketResearchQuery'
import { isAxiosError } from '@/api/business'
import Button from '@/components/Button'

interface DeleteDialogProps {
    ids:  number
    isOpen: boolean
    nameUser: string
    onClose: () => void
}

const DeleteDialog = ({ ids, isOpen, onClose, nameUser }: DeleteDialogProps) => {
    const queryClient = useQueryClient()
    const { toast } = useToast()

    const { mutate: mutateDelete, isPending: mutateLoading } = useMutation({
        mutationFn: deleteProductInMarketResearch,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: ProductInMarketResearchKeys.details() })
            onClose()
            toast({
                title: 'Produto excluido com sucesso',
            })
        },
        onError: (err) => {
            let errorMessage =
                'Não foi possível excluir o produto. Tente novamente mais tarde.'

            if (isAxiosError(err)) {
                errorMessage = err.response?.data.message || errorMessage
            }

            toast({
                title: 'Erro ao excluir usuário',
                description: errorMessage,
                variant: 'destructive',
            })
        },
    })

    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent>
                <DialogHeader>
                    <DialogTitle>Excluir Produto</DialogTitle>
                </DialogHeader>
                <div className="pt-4">
                    <p>
                        Realmente deseja excluir o produto <strong>{nameUser}</strong> da pesquisa?
                    </p>
                </div>
                <DialogFooter>
                    <Button onClick={onClose} variant="ghost">
                        Cancelar
                    </Button>
                    <Button
                        onClick={() => mutateDelete({SK_PRODUTOS_PESQUISA: ids})}
                        isLoading={mutateLoading}
                    >
                        Confirmar
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    )
}

export default DeleteDialog
